import { createAction } from 'modules/redux-store';

export const registrationAction = {
  success: () => createAction('REGISTRATION_SUCCESS'),
  error: () => createAction('REGISTRATION_ERROR'),
};
